import { wallBuilderInputsSlice } from './inputsSlice';
// Re-export Redux actions for backward compatibility
export const wallBuilderActions = wallBuilderInputsSlice.actions;
